import Vue from 'vue';
Vue.component('to-do-list-widget', require('./components/ToDoListWidget.vue').default);
Vue.component('to-do-list-single', require('./components/ToDoListSingle.vue').default);
Vue.component('flash-message', require('./components/FlashMessage.vue').default);
Vue.component('tool-tip', require('./components/ToolTip.vue').default);
Vue.component('general-modal', require('./components/GeneralModal.vue').default);
Vue.component('auto-save', require('./components/AutoSave.vue').default);

//fields
Vue.component('country-drop', require('./components/CountryPicker.vue').default);
Vue.component('date-range', require('./components/DateRange.vue').default);
Vue.component('file-picker', require('./components/FilePicker.vue').default);
Vue.component('job-type-drop', require('./components/JobTypeDrop.vue').default);
Vue.component('sic-industry-drop', require('./components/SicIndustryDrop.vue').default);
Vue.component('school-drop', require('./components/SchoolDrop.vue').default);
Vue.component('course-drop', require('./components/CourseCodeDrop.vue').default);
Vue.component('course-group-drop', require('./components/CourseGroupDrop.vue').default);
Vue.component('academic-year-drop', require('./components/AcademicYearDrop.vue').default);
Vue.component('placement-type-drop', require('./components/PlacementTypeDrop.vue').default);
Vue.component('admin-drop', require('./components/AdminDrop.vue').default);
Vue.component('radius-search', require('./components/RadiusSearch.vue').default);
Vue.component('school-campaign-drop', require('./components/SchoolCampaignDrop.vue').default);
Vue.component('single-date-picker', require('./components/SingleDatePicker.vue').default);
Vue.component('text-editor', require('./components/TextEditor.vue').default);
Vue.component('time-picker', require('./components/TimePicker.vue').default);
Vue.component('star-rating', require('./components/starRating.vue').default);
Vue.component('signature-box', require('./components/Signature.vue').default);
Vue.component('auto-complete', require('./components/AutoComplete.vue').default);
Vue.component('searchable-list-drop', require('./components/SearchableListDrop.vue').default);

//progressive web app
Vue.component('add-to-homepage', require('./components/pwa/AddToHomepage.vue').default);
Vue.component('push-notification-toggle', require('./components/pwa/PushNotificationToggle.vue').default);

//reported concerns
Vue.component('list-concern-modal', require('./components/ReportConcernModal.vue').default);

//profile page
Vue.component('profile-page', require('./components/ProfilePage.vue').default);
Vue.component('profile-page-report', require('./components/ProfilePageReport.vue').default);

// general components
Vue.component('add-to-list', require('./components/AddToList.vue').default);
Vue.component('progress-bar', require('./components/graphs/ProgressBar.vue').default);
Vue.component('admin-comments', require('./components/Comments.vue').default);
Vue.component('company-history', require('./components/CompanyHistory.vue').default);
Vue.component('notifier', require('./components/ChangeNotifier.vue').default);
Vue.component('question-button', require('./components/QuestionButton.vue').default);
Vue.component('review-block', require('./components/ReviewBlock.vue').default);
Vue.component('sticky-scroll', require('./components/StickyScroll.vue').default);

Vue.component('list-view-remove_cache', require('./components/RemoveListCache.vue').default);

Vue.component('job-progress', require('./components/graphs/JobProgress.vue').default);
Vue.component('log-back-in-modal', require('./components/LogBackInModal.vue').default);
Vue.component('contact-form', require('./components/ContactForm.vue').default);
Vue.component('v-multiselect', require('./components/MultiselectOptions.vue').default);

Vue.component('format-date', require('./components/FormatDate.vue').default);

const app = new Vue({
  el: '#app',
  //components
});

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
window.WEXHelper = require('./wex-helpers');
